export const selectUsersList = (state) =>
  state.users && state.users.items ? state.users.items : [];
export const selectUsersTotal = (state) =>
  state.users && state.users.total ? state.users.total : 0;
